const actions = {
    GET_CONFIGURATION: "configuration/GET_CONFIGURATION",
    SET_CONFIGURATION: "configuration/SET_CONFIGURATION",

    SET_INITIAL_CONFIGURATION: "addresses/SET_INITIAL_CONFIGURATION"

};

export default actions